<template>
	<div class="maintenance-page">
		<div class="maintenance-container">
			<div class="card shadow-lg border-0">
				<div class="card-body p-5 text-center">
					<div class="icon-wrapper mb-4">
						<i class="fe fe-settings text-primary" style="font-size: 80px"></i>
					</div>

					<h1 class="card-title text-primary font-weight-bold mb-3">System Maintenance In Progress</h1>

					<p class="lead text-muted mb-4">
						We apologize for the inconvenience. Our system is currently undergoing maintenance to improve performance and
						stability.
					</p>

					<p class="text-small mt-4">Thank you for your patience. Please check back soon.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MaintenancePage',
};
</script>

<style scoped>
.maintenance-page {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
	background-color: #f8f9fa;
}

.maintenance-container {
	padding: 20px;
	width: 100%;
	height: 100vh;
}

.icon-wrapper {
	background-color: #e3f2fd;
	border-radius: 50%;
	width: 120px;
	height: 120px;
	margin: 0 auto 30px auto;
	display: flex;
	justify-content: center;
	align-items: center;
}

.card {
	border-radius: 1rem;
}
</style>
